export default {
  components: {
    headerBlock: () => import('~/components/commom/header/index'),
    contactLayout: () => import('~/components/layouts/contact/index')
  }
}
